import { Remote } from "../../../core/components/remote/Remote.component";
import { coastMediaService } from "../../../core/services/Pws";
import { CoastOnAirStatus } from "./CoastOnAirStatus.component";

export const CoastOnAirStatusLoader = () => {
  return (
    <Remote
      loader={() => coastMediaService.getOnAirStatus()}
      cacheKey={`coast-on-air-status`}
      showLoading={true}
      fallback={<CoastOnAirStatus isLive={false} />}
    >
      {({ data }) => <CoastOnAirStatus isLive={!!data?.isOnAir} />}
    </Remote>
  );
};

export default CoastOnAirStatusLoader;
